export const showPdf = (base64Data) => {

  // Convierte la cadena base64 en un Blob
  const byteCharacters = atob(base64Data);
  const byteNumbers = Array.from(byteCharacters, char => char.charCodeAt(0));
  const byteArray = new Uint8Array(byteNumbers);
  const blob = new Blob([byteArray], { type: 'application/pdf' });

  const blobUrl = URL.createObjectURL(blob);

  return blobUrl
}